import { useState } from 'react';
import { TriggerStatus } from './types';

export const useSharedQueryTriggerStatus = () => {
    const [triggerStatus, setTriggerStatus] = useState<TriggerStatus>('init');

    return { triggerStatus, setTriggerStatus };
};
